export const defaultAcceptFileType =
  ".3g2, .3gp, .7z, .aac, .amr, .avi, .bmp, .csv, .doc, .docx, .eml, .gif, .heic, .heif, .ics, .jfif, .jpeg, .jpg, .key, .log, .m4a, .m4v, .mov, .mp3, .mp4, .mp4a, .mpeg, .mpg, .mpga, .neon, .numbers, .odt, .oga, .ogg, .ogv, .opus, .pages, .pdf, .png, .pps, .ppsx, .ppt, .pptx, .qt, .svg, .tif, .tiff, .txt, .vcf, .wav, .webm, .webp, .wmv, .xls, .xlsx, .xml, .yaml, .yml, .zip";

export const defaultMaxFileSizeInMB = 50;
